module.exports = __webpack_public_path__ + "static/media/instagram.2f4b803a.svg";